import baseApi from 'api/baseApi';
import { IBalanceSummary } from 'common/components/PersonProfile/interfaces';

const balanceApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getBalanceSummary: builder.query<IBalanceSummary, number>({
      query: personId => ({
        url: `/api/v1/members/${personId}/balance-summary`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetBalanceSummaryQuery: useLazyGetBalanceSummary } = balanceApi;

export default balanceApi;
